import Vue from 'vue';
import Preview from './src/preview';

const div = document.createElement('div');
document.body.appendChild(div);

const P = Vue.extend(Preview);
const instance = new P({ el: div });

Preview.install = function (Ctor) {
    Ctor.prototype.$preview = instance.preview;
}

module.exports = Preview;


// WEBPACK FOOTER //
// ./src/components/preview/index.js